var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.1772 16.4106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.1559 16.3374C1.04031 16.3028 0.874633 16.2257 0.789867 16.1718C0.585659 16.0446 0.296685 15.7287 0.192655 15.5245C-0.0038475 15.1392 5.48665e-06 15.3395 5.48665e-06 8.20378C5.48665e-06 1.0642 -0.0038475 1.26841 0.192655 0.87926C0.300538 0.671199 0.620336 0.332136 0.824544 0.212693C1.2137 -0.0146325 0.920869 -0.00692658 6.66952 0.00463237L11.925 0.0161913L12.1485 0.10481C12.4259 0.216546 12.8112 0.567168 12.9576 0.84073C13.1811 1.24915 13.1772 1.11429 13.1772 6.52773V11.4981L10.7229 13.9524L8.26465 16.4106L4.81623 16.4068C1.62982 16.4068 1.3524 16.4029 1.1559 16.3374ZM9.49761 12.7118L11.5397 10.6697H9.46678H7.39773V12.7118C7.39773 13.8368 7.40929 14.7539 7.42856 14.7539C7.44397 14.7539 8.37639 13.8368 9.49761 12.7118ZM4.0572 6.4892C4.55423 6.3582 4.81623 6.03455 4.81623 5.54137C4.81623 5.19075 4.75073 5.01351 4.52726 4.78618C4.28452 4.53959 3.96858 4.42786 3.50237 4.42786H3.19798V3.84991V3.27196H2.83195H2.46591L2.47362 4.88251L2.48518 6.4892L2.6393 6.51232C2.9668 6.56241 3.83372 6.547 4.0572 6.4892ZM7.00473 6.4892C7.47865 6.37747 7.81771 6.13858 8.00265 5.78796C8.29933 5.22928 8.2608 4.47409 7.90633 3.93468C7.59038 3.4492 7.02399 3.23729 6.0646 3.23343C5.78719 3.23343 5.50207 3.24499 5.43656 3.25655L5.31712 3.28352V4.89407V6.50462L5.4828 6.52003C5.92975 6.55856 6.7774 6.54315 7.00473 6.4892ZM10.7036 6.23105L10.7152 5.93052H10.0756H9.43981V5.54522V5.15992H10.037H10.6342V4.87095V4.58198H10.037H9.43981V3.92697V3.27196H9.07378H8.70775V4.90948V6.547L9.70182 6.53929L10.692 6.52773L10.7036 6.23105Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.26733 5.98105C3.20568 5.96564 3.19798 5.90784 3.19798 5.49172V5.0178L3.30971 4.99469C3.44842 4.96772 3.68345 5.00239 3.82216 5.06789C4.09572 5.2066 4.18049 5.58034 3.98398 5.81152C3.84913 5.97334 3.52548 6.0504 3.26733 5.98105Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.1956 5.98038L6.04918 5.96497V4.88228V3.80344L6.38825 3.81886C6.93922 3.84583 7.26287 4.08857 7.37461 4.55863C7.41699 4.73201 7.40543 5.24831 7.3592 5.37546C7.19352 5.8147 6.75813 6.03817 6.1956 5.98038Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.2a08033a5f6a9c0bc8139d80b0756a2e.svg";
export { ForwardRef as ReactComponent };